import { CollapsibleSection } from "components/collapsibleSection";
import { Tag } from "components/tag";
import { ISportParticipantDetail } from "interfaces";

export const EwaiverInformationSection = ({participantDetailData} : {participantDetailData: ISportParticipantDetail | null}) => {
  return (
    <CollapsibleSection 
      label="Ewaiver Information"
      defaultOpen={true}
    >
      <div className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6" style={{wordBreak: "break-word"}}>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-1">
          <div className="col-span-2">
            <p className="font-medium">
              Ewaiver status
            </p>
          </div>
          <div className="col-span-4">
            <Tag 
              text={participantDetailData?.participant.online_checked ? "Signed" : "Unsigned"}
              type={participantDetailData?.participant.online_checked ? "green" : "pink"}
            />
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-3">
          <div className="col-span-2">
            <p className="font-medium">
              Kyc by legal
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.kyc_by_legal ? "Yes" : "No"}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-5">
          <div className="col-span-2">
            <p className="font-medium">
              Ocr time 
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.ocr_time}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-7">
          <div className="col-span-2">
            <p className="font-medium">
              Name pick
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.name_pick}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-9">
          <div className="col-span-2">
            <p className="font-medium">
              Email pick
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.email_pick}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-11">
          <div className="col-span-2">
            <p className="font-medium">
              Max number of times to update pickup method
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.num_of_times_change_pickup}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-2">
          <div className="col-span-2">
            <p className="font-medium">
              Waiver sign completed
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.waiver_sign_completed ? "Yes" : "No"}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-4">
          <div className="col-span-2">
            <p className="font-medium">
              Kyc completed
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.kyc_completed ? "Yes" : "No"}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-6">
          <div className="col-span-2">
            <p className="font-medium">
              Face matching time
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.face_matching_time}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-8">
          <div className="col-span-2">
            <p className="font-medium">
              Phone pick
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.phone_pick}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-10">
          <div className="col-span-2">
            <p className="font-medium">
              ID card pick
            </p>
          </div>
          <div className="col-span-4">
            <p className="whitespace-pre-wrap">
              {participantDetailData?.participant.id_card_pick}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-12">
          <div className="col-span-2">
            <p className="font-medium">
              Max number of times to update authorized info
            </p>
          </div>
          <div className="col-span-4">
            <p className="whitespace-pre-wrap">
              {participantDetailData?.participant.num_of_times_update_authorized_info}
            </p>
          </div>
        </div>
      </div>
    </CollapsibleSection>
  )
}